import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Slot } from "core/types";
import { useState } from "react";
import { useSlotDateTimePicker } from "./slotDateTimePicker.hooks";

import { styled } from "styled-components";
import { Icon } from "@mindlercare/ui-web";

type SlotDateTimePickerProps = {
  slot: Slot & {
    psychologistId: number;
  };
};

const SlotDateTimePicker = ({ slot }: SlotDateTimePickerProps) => {
  const [open, setOpen] = useState(false);
  const { time, handleTimeChange, handleTimeUpdate, isMarketGB } =
    useSlotDateTimePicker({
      slot,
    });
  return (
    <DateTimeContainer>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          closeOnSelect={false}
          open={open}
          onClose={() => setOpen(false)}
          slotProps={{
            textField: {
              InputProps: {
                endAdornment: null,
                disableUnderline: true,
              },
              variant: "standard",
              onClick: () => setOpen(true),
            },
          }}
          format={`yyyy-MM-dd ${isMarketGB ? "hh:mm a" : "HH:mm"}`}
          value={time}
          onChange={handleTimeChange}
          onAccept={handleTimeUpdate}
          minutesStep={5}
          disablePast
          ampm={isMarketGB}
        />
      </LocalizationProvider>
      <Icon.Calendar />
    </DateTimeContainer>
  );
};

const DateTimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  gap: 6px;
  width: 279px;
  height: 48px;
  border-radius: 4px;

  flex-direction: row;
  border: ${({ theme }) => `1px solid ${theme.COLORS.GRAY_MEDIUM}`};
`;

export default SlotDateTimePicker;
